import {v4 as uuidv4} from 'uuid';

export type PageMetricSessionState = {
  uid: string;
  pageName: string;
  startTime: number;
  context: Record<string, unknown>;
};

let activeSession: PageMetricSessionState | null = null;

type InitPerfMetricSessionOptions = {
  uid?: string;
  startTime?: number;
};

export function initPageMetricSession(
  pageName: string,
  context: Record<string, unknown> = {},
  options: InitPerfMetricSessionOptions = {}
): PageMetricSessionState {
  activeSession = {
    uid: options.uid ?? uuidv4(),
    pageName,
    startTime: options.startTime ?? Date.now(),
    context,
  };
  return activeSession;
}

export function endPageMetricSession(uid?: string): void {
  if (!uid || activeSession?.uid === uid) {
    activeSession = null;
  }
}

export function getPerfMetricSession(): PageMetricSessionState | null {
  return activeSession;
}

export function getSessionElapsed(): number | null {
  if (!activeSession) {
    return null;
  }
  return Date.now() - activeSession.startTime;
}
